import { useEffect } from 'react'
import { Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { baseModel } from '../model'
import { IDetail } from '../service'
import { FormOutlined, EyeOutlined, SendOutlined, ExportOutlined } from '@ant-design/icons'
import { Button } from 'antd/lib/radio'

export function DataTable() {
    const {
        dataSource,
        selectedRowKeys,
        pgCfg,
        loading,
        setEditVisible,
        setDetailVisible,
        loadData,
        setSelectedRowKeys,
        getStatusName,
        setItemColor,
        handlePublish,
        setMode,
        getDriverList,
        handleExport
    } = baseModel()

    useEffect(() => {
        void loadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const columns: ColumnsType<IDetail> = [
        {
            title: '序号',
            width: 60,
            align: 'center',
            render: (_t, _r, i) => i + 1
        },
        {
            title: '操作',
            width: 200,
            align: 'left',
            render: (_text, record) => {
                const statusText: string = getStatusName(record.status as string)
                return (
                    <>
                        {['草拟'].includes(statusText) && (
                            <>
                                <Button
                                    onClick={async () => {
                                        await getDriverList()
                                        setMode('edit')
                                        setEditVisible({ visible: true, value: { ...record } })
                                    }}
                                >
                                    <FormOutlined style={{ cursor: 'pointer' }} title={'编辑'} />
                                </Button>
                                <Button onClick={() => handlePublish(record)}>
                                    <SendOutlined style={{ cursor: 'pointer' }} title={'发布'} />
                                </Button>
                                <Button onClick={() => handleExport([record.id as string])}>
                                    <ExportOutlined style={{ cursor: 'pointer' }} title={'导出'} />
                                </Button>
                            </>
                        )}
                        <Button onClick={() => setDetailVisible({ visible: true, value: { ...record } })}>
                            <EyeOutlined style={{ cursor: 'pointer' }} title={'查看'} />
                        </Button>
                    </>
                )
            }
        },
        {
            title: '主题',
            width: 250,
            align: 'center',
            dataIndex: 'title'
        },
        {
            title: '开始时间',
            width: 160,
            align: 'center',
            dataIndex: 'startTime'
        },
        {
            title: '结束时间',
            width: 160,
            align: 'center',
            dataIndex: 'endTime'
        },
        {
            title: '是否回执',
            width: 160,
            align: 'center',
            dataIndex: 'needReceipt'
        },
        {
            title: '创建人',
            width: 200,
            align: 'center',
            dataIndex: 'createUser'
        },
        {
            title: '状态',
            width: 160,
            align: 'center',
            dataIndex: 'status',
            render: (_text, record) => (
                <>
                    <span className={'text b-text ' + setItemColor(record.status as string)}>
                        {record.status || record.status === 0 ? getStatusName(record.status as string) : '-'}
                    </span>
                </>
            )
        }
    ]

    //点击行选高亮
    const onRow = (record: IDetail) => {
        let findObj = selectedRowKeys.find((item) => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter((item) => item.id !== record.id)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            setSelectedRowKeys((origin) => [...origin, record])
        }
    }

    return (
        <Table
            rowKey={(record) => record?.id as string}
            loading={loading}
            rowSelection={{
                // 修改这里
                //全部选中时 (存row[])
                onSelectAll: (selected, _selectedRows, changeRows) => {
                    selected
                        ? setSelectedRowKeys((origin) => [...origin, ...changeRows.filter((item) => item.status !== 1 && item.status !== 2)])
                        : setSelectedRowKeys((origin) => {
                            let changeRowId = changeRows.map((item) => item.id)
                            return origin.filter((item) => changeRowId.indexOf(item.id) < 0)
                        })
                },
                onSelect: (record) => {
                    if (record.status !== 1 && record.status !== 2) {
                        onRow(record)
                    }
                },
                selectedRowKeys: selectedRowKeys.map((item) => item.id as string)
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ['bottomRight'],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: async (pageNum, pageSize) => {
                    await loadData({ pageNum, pageSize })
                },
                showSizeChanger: true
            }}
            bordered
            onRow={(record) => ({
                onClick: () => {
                    if (record.status !== 1 && record.status !== 2) {
                        onRow(record)
                    }
                },
                onContextMenu: (e) => {
                    e.preventDefault()
                    if (record.status !== 1 && record.status !== 2) {
                        setSelectedRowKeys([record])
                    }
                }
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 350px)' }}
        />
    )
}
